<template>
  <div
    :id="`${source}_create_list_dropdown`"
    class="flex proxima_nova flex-col min-w-[260px] w-full text_color font-medium"
  >
    <div class="flex flex-col gap-4 p-2">
      <div
        class="flex flex-row gap-2 text-sm items-center cursor-pointer"
        @click="$emit('goBack')"
      >
        <ThemeImage
          class="size-4"
          :icon="imageNames.BACK_ARROW_WHITE"
          alt="back_arrow_white"
          aria-label="Go back"
        />
        <span>Create List</span>
      </div>

      <a-input
        id="list_name"
        v-model:value="entity.name"
        class="input_medium"
        placeholder="Enter list name"
        allow-clear
      />

      <div id="private_list" class="flex flex-row items-center gap-2">
        <a-checkbox v-model:checked="entity.privateFlag" />
        <div class="flex flex-row items-center gap-1">
          <span class="text-[13px]">Mark as private list</span>
          <ThemeImage
            class="w-[14px] h-[14px]"
            :icon="imageNames.LOCK_GREY"
            alt="lock_icon"
          />
        </div>
      </div>
    </div>

    <div class="flex flex-row justify-between p-2 border_top">
      <a-button class="secondary_medium" @click="$emit('goBack')"
        >Cancel</a-button
      >
      <a-button class="primary_medium" @click="createEntityList"
        >Create</a-button
      >
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { message } from "ant-design-vue";

import DashboardService from "@/src/api/DashboardService.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  entityType: { type: String, required: false },
  prospecting: { type: Boolean, default: false },
});

const emit = defineEmits(["entityListCreated", "goBack"]);

const entity = ref({
  name: "",
  privateFlag: false,
});

const resetSearchState = () => {
  entity.value = {
    name: "",
    privateFlag: false,
  };
};

const createEntityList = async () => {
  if (!entity.value.name) {
    message.error("Please enter a list name");
    return;
  }

  try {
    const payload = {
      list_name: entity.value.name,
      entity_type: (props.entityType || props.source).toLowerCase(),
      private_flag: entity.value.privateFlag,
    };

    const response = await DashboardService.createEntityList(payload);
    if (response?.success) {
      emit("entity-list-created", { 
        id: response.entity_list || response.listId, 
        list_name: payload.list_name 
      });
      if (!props.prospecting) {
        message.success(`${payload.list_name} list created successfully`);
      }
      entity.value = { name: "", privateFlag: false };
    }
  } catch (error) {
    console.error("Error creating entity list:", error);
    message.error(
      error.message || "An error occurred while creating the entity list",
    );
  }
};

defineExpose({
  resetSearchState,
});
</script>
